module.exports = __webpack_public_path__ + "static/media/global currency.2da83d3e.svg";